export const UID = "uid";
export const CUSTOMER_INFO = "customerInfo";
export const EMAIL_PREFERENCE_VALUE = "email";
export const MOBILE_PREFERENCE_VALUE = "mobile";

export const USERNAME = "username";
export const CHALLENGE = "login_challenge";
export const PASSWORD = "password";
export const TOKEN = "Token";
export const LOGIN_FORM_ID = "loginForm";
export const EMAIL_HINT = "email_hint";
export const LOGIN_AFTER_REGISTRATION_FORM_ID = "registrationLoginForm";
export const FROM_REGISTRATION = "from_registration";

export const DATA_CHALLENGE = "data-challenge";
export const DATA_ERROR = "data-error";
export const DATA_CUSTOMER_INFO = "data-customer-info";
